export const SET_LISA_MINIMIZED = "SET_LISA_MINIMIZED";
export const SET_LISA_LIBRARY = "SET_LISA_LIBRARY";
export const SET_LISA_PLAYER_IS_ACTIVE = "SET_LISA_PLAYER_IS_ACTIVE";
